export default __webpack_public_path__ + "static/media/itours-logo-2.25bc716b.svg";